import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { NotificationProvider } from "shared-lib";
import { auth } from "./firebase";
import { signInWithPopup, signOut, OAuthProvider, User } from "firebase/auth";
import AdminPanel from "./pages/AdminPanel";
import "./App.css";

function App() {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
      setUser(firebaseUser);
    });

    return () => unsubscribe();
  }, []);

  const logIn = async () => {
    try {
      const provider = new OAuthProvider('microsoft.com');
      provider.setCustomParameters({
        prompt: 'select_account'
      });
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Sign in failed:", error);
    }
  };

  const logOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Sign out failed:", error);
    }
  };

  if (!user) {
    return (
      <div className="App">
        <header className="App-header">
          <h1>Rent Ready Bids Administration</h1>
        </header>
        <main>
          <button onClick={logIn}>Sign in with Microsoft</button>
        </main>
      </div>
    );
  }

  return (
    <div className="App">
      <NotificationProvider>
        <header className="App-header">
          <div className="user-info">
            <span>{user.displayName}</span>
            <button onClick={logOut}>Sign Out</button>
          </div>
          <h1>Rent Ready Bids Administration</h1>
        </header>
        <main>
          <Routes>
            <Route path="/" element={<AdminPanel />} />
            {/* Add more routes as needed */}
          </Routes>
        </main>
      </NotificationProvider>
    </div>
  );
}

export default App;
